import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { BsChatLeftTextFill, BsFillTelephoneFill, BsTelephone } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { IoLocationSharp, IoMailOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../../components/modal/Modal";
import AboutUs from "./AboutUs/AboutUs";
import Documents from "./documents/Document";
import Services from "./services/Services";
import styles from "./yourVendorDetails.module.css";
import {
  AntdTab,
  Box,
  DeleteModal,
  ServiseProfileComponent,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { IoIosShareAlt } from "react-icons/io";
import { RiDeleteBin6Line } from "react-icons/ri";
import CopyLinkModal from "../../../../components/copyLinkModal/CopyLinkModal";
import { LocIcon } from "../../../../components/icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";

const items = [
  {
    key: "1",
    label: "About Us",
    children: (
      <>
        <Row className={styles.tabContentCont}>
          <AboutUs />
        </Row>
      </>
    ),
  },
  {
    key: "2",
    label: "Services",
    children: (
      <Row className={styles.tabContentCont}>
        <Services />
      </Row>
    ),
  },
  {
    key: "3",
    label: "Documents",
    children: (
      <Row className={styles.tabContentCont}>
        <Documents />
      </Row>
    ),
  },
];

const SubContacrDetails = () => {
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setloader] = useState(false);
  const Details = useSelector((state) => state.VendorReducer.VendorDetails);
// console.log("detailsssss", Details);
  const {state} = useLocation();
  const navigate = useNavigate();
  const dispatch =  useDispatch();
  const prevData = state?.data;
  const event_id = state?.event_id;
  const onChange = (key) => {
    console.log(key);
  };
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setloader(true);
    let data = {
      vendor_id: prevData?.id,
      event_id: event_id,
    };
    dispatch(VendorMiddleware.getDetails(data))
      .then((res) => {
        // setDetails(res);
        setloader(false);
      })
      .catch(() => {
        setloader(false);
      });
  };
  return (
    <>
      <ServiseProfileComponent image={state.img}>
        <Col>
          <Row className={styles.contentCont}>
            <Col>
              <Row>
                <TextComponent text={state.title} textClass={styles.name} />
              </Row>
              <Row>
                <TextComponent
                  text={state.category}
                  textClass={styles.type}
                />
              </Row>
            </Col>
            <Col className={styles.iconsCont}>
              <Box
                boxClass={styles.iconBox}
                onClick={() =>
                  navigate("/findVendors/EditVendors", {
                    state: { headrTitle: "Edit Vendor" },
                  })
                }
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3374 7.07412C20.9757 7.07412 20.6289 7.22106 20.3731 7.4826C20.1174 7.74414 19.9737 8.09887 19.9737 8.46875V16.7668C19.9716 17.5059 19.6835 18.214 19.1725 18.7366C18.6615 19.2593 17.9691 19.5538 17.2464 19.556H6.33736C5.6147 19.5538 4.92226 19.2593 4.41127 18.7366C3.90027 18.214 3.61224 17.5059 3.61009 16.7668V5.60976C3.61224 4.87068 3.90027 4.16251 4.41127 3.6399C4.92226 3.11729 5.6147 2.82271 6.33736 2.82051H14.451C14.8127 2.82051 15.1595 2.67357 15.4152 2.41203C15.671 2.15049 15.8146 1.79576 15.8146 1.42588C15.8146 1.056 15.671 0.701271 15.4152 0.439727C15.1595 0.178184 14.8127 0.03125 14.451 0.03125H6.33736C4.89205 0.0356646 3.50717 0.624817 2.48518 1.67004C1.46319 2.71525 0.887129 4.13161 0.882812 5.60976V16.7668C0.887129 18.2449 1.46319 19.6613 2.48518 20.7065C3.50717 21.7517 4.89205 22.3409 6.33736 22.3453H17.2464C18.6918 22.3409 20.0766 21.7517 21.0986 20.7065C22.1206 19.6613 22.6967 18.2449 22.701 16.7668V8.46875C22.701 8.09887 22.5573 7.74414 22.3016 7.4826C22.0459 7.22106 21.699 7.07412 21.3374 7.07412ZM10.8374 12.5132C10.9605 12.6453 11.1086 12.7505 11.2727 12.8224C11.4368 12.8943 11.6134 12.9314 11.7919 12.9314C11.9704 12.9314 12.147 12.8943 12.3111 12.8224C12.4752 12.7505 12.6233 12.6453 12.7464 12.5132L20.5874 4.49406C20.8363 4.23425 20.975 3.88447 20.9732 3.52071C20.9714 3.15695 20.8293 2.80861 20.5778 2.55139C20.3263 2.29417 19.9857 2.14885 19.63 2.14702C19.2743 2.14518 18.9323 2.28697 18.6783 2.54158L10.8374 10.5607C10.7081 10.6866 10.6053 10.8381 10.535 11.0059C10.4647 11.1737 10.4285 11.3544 10.4285 11.5369C10.4285 11.7195 10.4647 11.9001 10.535 12.0679C10.6053 12.2358 10.7081 12.3872 10.8374 12.5132Z"
                    className={styles.icon}
                  />
                </svg>
              </Box>
              <Box
                boxClass={styles.iconBox}
                onClick={() => setDeleteModalOpen(true)}
              >
                <RiDeleteBin6Line size={20} className={styles.icon} />
              </Box>
              <Box
                boxClass={styles.iconBox}
                onClick={() => {
                  setIsCopyModalOpen(true);
                }}
              >
                <IoIosShareAlt size={20} className={styles.icon} />
              </Box>
            </Col>
          </Row>
          <Row className={styles.locCont}>
            <BsTelephone className={styles.locIcon} size={20} />
            <TextComponent text={"Contact :"} textClass={styles.DetailHead} />
            <TextComponent text={"+1 (234) 456-4567"} textClass={styles.locText} />
          </Row>
          <Row className={styles.locCont}>
            <IoMailOutline className={styles.locIcon} size={20} />
            <TextComponent text={"Email : "} textClass={styles.DetailHead} />
            <TextComponent
              text={"trishjames@gmail.com"}
              textClass={styles.locText}
            />
          </Row>
          <Row className={styles.locCont}>
            <LocIcon className={styles.locIcon} size={20}/>
            <TextComponent text={"Address :"} textClass={styles.DetailHead} />
            <TextComponent text={"Fairfield - US"} textClass={styles.locText} />
          </Row>
        </Col>
      </ServiseProfileComponent>
      <AntdTab items={items} />
      <CopyLinkModal
        isCopyModalOpen={isCopyModalOpen}
        setIsCopyModalOpen={setIsCopyModalOpen}
        link="https://bestdayever-web.web.app"
      />
      <DeleteModal
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        delDesc={"Do you want to delete this"}
        title={"Vendor"}
      />
    </>
  );
};

export default SubContacrDetails;
